import { Card } from "react-bootstrap";

import MoneyFormat from "../../components/MoneyFormat";
import { useUser } from "../../UserContext";

const TransactionHistoryCard = () => {
	const { user: { orders } } = useUser();
	return (
		<Card body className="bg-white h-100">
			<h2>Transaction History</h2>
			<ul className="unstyled p-0">
				{orders.map(({
					databaseId: id,
					date,
					total
				}) => (
					<li className="d-flex gap-1" key={id}>
						<span>{new Date(date).toLocaleDateString()}</span>
						<span
							className="flex-fill border-bottom-dark"
							style={{  borderBottom: "1px dashed var(--bs-dark)" }}
						/>
						<span><MoneyFormat value={total/100} /></span>
						{/* <a href="#download-receipt">Receipt</a> */}
					</li>
				))}
			</ul>
		</Card>
	);
}

export default TransactionHistoryCard;